<template>
  <div>
    <slot name="label">
      <template v-if="label">
        <label>{{label}}</label>
        <br>
      </template>
    </slot>
    <el-select class="select-default max-step-width site-autocomplete"
               filterable
               autocomplete="new-password"
               :value="siteValue"
               :loading="loading"
               remote
               clearable
               @change="onChange"
               :placeholder="$t('generic.searchOrCreate')"
               v-bind="$attrs"
               value-key="name">
      <el-option v-for="site in sites"
                 class="select-default"
                 :key="site.id"
                 :label="site.name"
                 :value="site">
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui';
  import { mapState } from 'vuex';

  export default {
    name: 'site-autocomplete',
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      site: {
        type: Object,
        default: () => {
          return {
            name: ''
          }
        }
      },
      label: {
        type: String
      }
    },
    model: {
      prop: 'site',
      event: 'change'
    },
    data() {
      return {
        loading: false,
      }
    },
    computed: {
      siteValue() {
        if (!this.site.id) {
          return this.site.name;
        }
        return this.site;
      },
      ...mapState({
        sites: state => state.config.jobBoards
      })
    },
    methods: {
      onChange(val) {
        let model = val;
        if (typeof val === 'string') {
          model = {
            name: val
          };
        }
        this.$emit('change', model);
      }
    }
  }
</script>
<style lang="scss">
  .site-autocomplete {
    &.max-step-width {
      width: 100%;
      max-width: 100%;
    }
  }
</style>
